export const GOI_SERVICE_URL = "https://goifuneral.co.kr";
